<div
     [ngClass]="{
       'app-wrapper': true,
       'landing2025-active': isNewLandingActive(outlet)
     }"
     [@routeAnimations]="prepareRoute(outlet)">
    <!-- <app-models-navbar *ngIf="modelsSection" [breadCrumbs]="pageBreadcrumbs"></app-models-navbar> -->
    <router-outlet #outlet="outlet"></router-outlet>
    <!-- used for caching required data -->
    <div class="preloader"></div>
</div>
<app-cookie-consent *ngIf="cookieConsent"></app-cookie-consent>
